import HeaderLogo from '../../../components/headerLogo';
import ProfileHeader from '../../../module/profile/header';
import ProfileMenuItems from '../../../module/profile/menuItems';

const Profile = () => {
  return (
    <>
      <HeaderLogo />
      <div className="px-3">
        <div className="my-3">
          <ProfileHeader />
        </div>
        <ProfileMenuItems />
      </div>
    </>
  );
};

export default Profile;
